import type { CalendarEventReminderInfoForType } from "@tellescope/types-models";
import { Checkbox, Input, Label } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

type CreateTicketReminder = CalendarEventReminderInfoForType["create-ticket"];

export interface CreateTicketInfoSectionProps {
  value: CreateTicketReminder;
  onChange: (newValue: CreateTicketReminder) => void;
}

export const CreateTicketInfoSection = ({ value, onChange }: CreateTicketInfoSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <>
      <div className="flex flex-col gap-1">
        <Label htmlFor="create-ticket-title" className="text-xs">
          {t("Ticket title")}
        </Label>
        <Input
          id="create-ticket-title"
          value={value.info.title}
          onChange={(e) =>
            onChange({
              ...value,
              info: {
                ...value.info,
                title: e.target.value,
              },
            })
          }
          placeholder={t("Ticket title")}
        />
      </div>
      <span className="flex gap-2 items-center">
        <Checkbox
          id="create-ticket-send-even-if-passed"
          checked={!value.dontSendIfPassed}
          onCheckedChange={(checked) =>
            onChange({
              ...value,
              dontSendIfPassed: !checked,
            })
          }
        />
        <Label htmlFor="create-ticket-send-even-if-passed" className="text-muted-foreground text-xs font-light">
          {t("Send even if timing has passed")}
        </Label>
      </span>
    </>
  );
};
